'use client';

import Link from 'next/link';
import { ArrowLeft, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  return (
    <main className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background px-6">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,hsl(var(--primary)/0.08)_0%,transparent_70%)]" />

      <div className="relative flex flex-col items-center gap-6">
        <p className="text-[8rem] font-black leading-none tracking-tighter text-foreground/5 sm:text-[12rem]">
          404
        </p>

        <div className="-mt-16 flex flex-col items-center gap-2 sm:-mt-20">
          <h1 className="text-xl font-semibold text-foreground">页面走丢了</h1>
          <p className="max-w-sm text-center text-sm text-muted-foreground">
            你要找的页面不存在，可能已被移除或地址有误
          </p>
        </div>

        <div className="mt-2 flex items-center gap-3">
          <Button variant="outline" size="sm" asChild>
            <Link href="/">
              <ArrowLeft className="mr-1.5 size-3.5" />
              返回首页
            </Link>
          </Button>
          <Button size="sm" asChild>
            <Link href="/">
              <Search className="mr-1.5 size-3.5" />
              去搜文献
            </Link>
          </Button>
        </div>
      </div>
    </main>
  );
}
